import Token from '@web/common/token'
import client from '@web/api/client'
import OrderMapper from '@web/mapper/OrderMapper'
import { withQueryParams } from '@web/common/url'

export default class Order {
  static create (serviceId: number) {
    return client.post(withQueryParams(`/order/${serviceId}`, { token: Token.get() }))
      .then(response => OrderMapper.toClient(response.data))
  }
}
